import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReturnInvoicesListComponent } from './return-invoices-list.component';
import { PosTableModule } from 'src/app/shared/pos-table/pos-table.module';
import { HasPrivilegeModule } from 'src/app/@core/directives/has-privilege/has-privilege.module';



@NgModule({
  declarations: [ReturnInvoicesListComponent],
  imports: [
    CommonModule,
    PosTableModule,
    HasPrivilegeModule
  ],
  exports: [ReturnInvoicesListComponent]
})
export class ReturnInvoicesListModule { }
